import { Factory, trait, association } from 'miragejs';
import { faker } from '@faker-js/faker';

/**
 * Adds a new "block attribute" to a mailer-section-block model settings
 *
 * @param {object} mailerSectionBlock MailerSectionBlock
 * @param {string} key attribute identifier
 * @param {object} attribute block attribute
 */
function withAttribute(mailerSectionBlock, key, attribute) {
  const settings = mailerSectionBlock?.settings || {};
  const attributes = settings?.attributes || [];
  mailerSectionBlock.update({
    settings: {
      ...settings,
      attributes: [...attributes, { [key]: createAttribute(attribute) }],
    },
  });
}

/**
 * Decorates attribute object with default values
 *
 * @param {object} attribute MailerSectionBlock settings attribute
 * @returns {object} decorated attribute object
 */
function createAttribute(attribute) {
  return {
    title: faker.lorem.words(2),
    locale_file_fallback_key: null,
    ...attribute,
  };
}

export default Factory.extend({
  mailerBlock: association(),

  settings: () => ({}),

  withImmutableText: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'immutable', {
        input_validation: 'immutable',
        type: 'immutable_text',
        value: null,
      });
    },
  }),

  withString: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'string', {
        input_validation: 'string',
        type: 'string',
        value: '',
      });
    },
  }),

  withAddress: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'address', {
        input_validation: 'address',
        locale_file_fallback_key: null,
        title: 'Use address or virtual link',
        type: 'string',
        value: null,
      });
    },
  }),

  withDirections: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'directions', {
        input_validation: null,
        locale_file_fallback_key: null,
        title: 'Get directions link',
        type: 'checkbox',
        value: true,
      });
    },
  }),

  withCheckbox: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'checkbox', {
        input_validation: 'checkbox',
        type: 'checkbox',
        value: false,
      });
    },
  }),

  withHtml: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'html', {
        input_validation: 'html',
        type: 'html',
        value: '',
      });
    },
  }),

  withDynamicString: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'dynamic', {
        input_validation: 'dynamic_string',
        locale_interpolation_variables: ['location_name', 'company_name'],
        type: 'dynamic_string',
        value: 'location: %{location_name}',
      });
    },
  }),

  withDropdown: trait({
    afterCreate(mailerSectionBlock) {
      withAttribute(mailerSectionBlock, 'dropdown', {
        input_validation: 'dropdown',
        type: 'dropdown',
        options: [
          { name: 'Some Dropdown Option', identifier: 'first_option' },
          { name: 'Second Dropdown Option', identifier: 'second_option' },
        ],
        value: '',
      });
    },
  }),

  asDeactivatable: trait({
    afterCreate(mailerSectionBlock) {
      mailerSectionBlock.mailerBlock.update({
        deactivatable: true,
      });
    },
  }),

  asNotDeactivatable: trait({
    afterCreate(mailerSectionBlock) {
      mailerSectionBlock.mailerBlock.update({
        deactivatable: false,
      });
    },
  }),
});
